var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.442,
    height: 18.196
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-share",
    d: "M13.7 12.861a2.66 2.66 0 00-1.79.7L5.4 9.774a2.528 2.528 0 000-1.279l6.44-3.754a2.734 2.734 0 10-.877-2 2.99 2.99 0 00.082.639L4.6 7.134a2.74 2.74 0 100 4l6.5 3.8a2.577 2.577 0 00-.073.594 2.667 2.667 0 102.673-2.667z",
    fill: "#fff"
  })));
}
export default SvgShareIcon;